import * as bootstrap from 'bootstrap';

console.log("hello world!");

const confirm_btn = document.getElementById("btn-confirm");

confirm_btn.addEventListener("click", () => window.alert("Okay Cool!"))